export default __webpack_public_path__ + "static/media/892.edffb60b.png";